export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=7b534f7f&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/burger-btn/index.vue?vue&type=template&id=7b534f7f&
// module id = 1307
// module chunks = 0